import React, { useRef, useEffect, forwardRef, useState } from "react";
import Barcode from "react-barcode";
import logo from '../Assets/balaji logo.png';
import "./PrintSlip.css";

const PrintSlip = forwardRef((props, ref) => {
  const { orderData } = props;
  const [bwLogo, setBwLogo] = useState(null);

  const canvasEl = useRef(null);
  const shadowRootHostEl = useRef(null);


   useEffect(() => {
    const img = new Image();
    img.crossOrigin = "anonymous"; // safe for local import, helps with CORS if needed
    img.src = logo;
    img.onload = () => {
      // desired width in px — keep reasonably small for thermal printers
      const targetWidth = Math.min(img.width, 300);
      const scale = targetWidth / img.width;
      const cw = Math.round(img.width * scale);
      const ch = Math.round(img.height * scale);

      const c = document.createElement("canvas");
      c.width = cw;
      c.height = ch;
      const ctx = c.getContext("2d");

      // draw image resized
      ctx.drawImage(img, 0, 0, cw, ch);

      // convert to grayscale and threshold (1-bit)
      const imageData = ctx.getImageData(0, 0, cw, ch);
      const data = imageData.data;
      // You can tune threshold (0-255). 128 is middle; lower -> darker image.
      const threshold = 140;
      for (let i = 0; i < data.length; i += 4) {
        const r = data[i], g = data[i + 1], b = data[i + 2];
        // luminance (BT.601)
        const lumin = 0.299 * r + 0.587 * g + 0.114 * b;
        const v = lumin < threshold ? 0 : 255;
        data[i] = data[i + 1] = data[i + 2] = v;
        data[i + 3] = 255;
      }
      ctx.putImageData(imageData, 0, 0);

      // Export as PNG (no alpha)
      const dataUrl = c.toDataURL("image/png");
      setBwLogo(dataUrl);
    };
    img.onerror = () => {
      // fallback: keep original imported path (may still not print)
      setBwLogo(logo);
    };
  }, []);



  useEffect(() => {
    const ctx = canvasEl.current?.getContext("2d");
    if (ctx) {
      ctx.beginPath();
      ctx.arc(95, 50, 40, 0, 2 * Math.PI);
      ctx.stroke();
      ctx.fillStyle = "rgb(200, 0, 0)";
      ctx.fillRect(85, 40, 20, 20);
      ctx.save();
    }
  }, []);

  React.useEffect(() => {
    if (shadowRootHostEl.current && !shadowRootHostEl.current.shadowRoot) {
      const shadowRoot = shadowRootHostEl.current.attachShadow({ mode: 'open' });
      const div = document.createElement('div');
      div.innerHTML = 'Shadow DOM Content';
      shadowRoot.appendChild(div);
    }
  }, []);

  if (!orderData || orderData.length === 0) return null;

  const order = orderData[0];
  const orderDate = new Date(order?.created_on || Date.now());
  const formattedDate = orderDate.toLocaleDateString("en-GB");

  // compute actual current time (with seconds). If a time offset is passed via props
  // (milliseconds), use it to adjust the displayed clock so it matches authoritative time.
  const offset = props.timeOffsetMs || 0;
  const actualNow = new Date(Date.now() + offset);
  const pad = (n) => String(n).padStart(2, '0');
  const actualTimeStr = `${pad(actualNow.getHours())}:${pad(actualNow.getMinutes())}:${pad(actualNow.getSeconds())}`;

  const formatSessionTime = (time24) => {
    if (!time24) return "N/A";
    const [hours, minutes] = time24.split(":");
    const hours12 = (hours % 12) || 12;
    const ampm = hours >= 12 ? "PM" : "AM";
    return `${hours12}:${minutes} ${ampm}`;
  };
  return (
    <div className="print-slip" ref={ref}>
      <div className="slip-container">
        <div className="logo-container">
           <img src={bwLogo || logo} alt="Logo" className="logo" />
        </div>

        <div className="text-center">
          <span>Date:{formattedDate}</span>
          <span><strong> Session Time:</strong> {formatSessionTime(order?.session_time)}</span>
        </div>
        <div className="text-center">
          <span><strong> Oeder Placed At:</strong> {actualTimeStr}</span>
        </div>

        <div className="text-center shop-order">
          <span><strong>Shop:</strong> {order?.first_name}</span>
          <span style={{ marginLeft: '6px' }}><strong>Order No:</strong> {order?.order_number}</span>
        </div>

        <hr />

        <div className="order-details">
          {order?.order_detail?.map((d, i) => (
            <span key={i}>| {d?.product_number}:{parseFloat(d?.invested_amount)} |</span>
          ))}
        </div>

        <hr />

        <p className="total">
          <strong>Total Amount: {parseFloat(order?.total_invested_amount || 0)} Rs.</strong>
        </p>
        <div className="barcode-container">
          <Barcode
            value={order?.order_number || "N/A"}
            width={2}
            height={30}
            displayValue={true}
            fontSize={10}
            margin={0}
          />
        </div>

      </div>
      <div ref={shadowRootHostEl} />
    </div>

  );
});

export default PrintSlip;
